/**
 * Created by Ivan on 04.09.2025
 */

const SpaceraceLevelsAdapter = {
    SubscribeToEvents: function () {
        if (!cleverapps.config.features.includes("space_race")) {
            return;
        }

        cleverapps.eventBus.on("outcome", (outcome) => {
            if (outcome === GameBase.OUTCOME_VICTORY) {
                cleverapps.personalBest.addPoint("spacerace", 1);
            }

            const mission = cleverapps.missionManager.findByType(Mission.TYPE_SPACE_RACE);
            if (!mission || !mission.isRunning() || !mission.logic.isUnlocked()) {
                return;
            }

            if (outcome === GameBase.OUTCOME_VICTORY) {
                mission.logic.incProgress();
            } else if (outcome === GameBase.OUTCOME_LOST) {
                mission.logic.resetProgress();
            }
        });
    }
};

cleverapps.whenAllInitialized(() => SpaceraceLevelsAdapter.SubscribeToEvents());